import GroupRadioButton from "../../../common-scripts/CustomFields/GroupRadioButton";
import CheckBox from "../../../common-scripts/CustomFields/CheckBox";
import React, {useContext, useEffect, useState} from "react";
import * as Yup from 'yup';
import {AppContext} from "../Context";
import {useFormik} from "formik";
import CustomTooltip from './../CustomTooltip';
/**
 * Step Autres dispositions
 *
 * @param texteInfos
 * @param userData
 * @param checkReadyForSaving
 * @returns {JSX.Element}
 * @constructor
 */
const StepWillsOther = ({ texteInfos, userData = null, checkReadyForSaving}) => {
	const {currentStep, dispatchStepEvent, datas, setdatas, referencesUrls} = useContext(AppContext);

	const initialValues =(userData != undefined || userData != null) ? userData : {
		otherDispositions: {
			floralComposition: {
				status: '',
				type: '',
			},
			typeOfCoffin: '',
			funeralHomeStay: '',
			conservationCare: '',
			pressNotices: '',
			announcement: '',
			announcementText: '',
			otherDispositions: ''
		},
		authorizeFuneralOrganization: false,
		authorizeSensitiveData: false,
	}

	const validationSchema = Yup.object({
		otherDispositions: Yup.object().shape({
			floralComposition: Yup.object(),
			typeOfCoffin: Yup.string().notRequired(),
			funeralHomeStay: Yup.string().notRequired(),
			conservationCare: Yup.string().notRequired(),
			pressNotices: Yup.string().notRequired(),
			announcement: Yup.string().notRequired(),
			announcementText: Yup.string().notRequired(),
			otherDispositions: Yup.string().notRequired()
		}),
		authorizeFuneralOrganization: Yup.bool().required(''),
		authorizeSensitiveData: Yup.bool().when('otherDispositions.otherDispositions', {
			is: value => value && value.length !== '',
			then: Yup.bool().test({
				name: 'is-mandatory',
				test: value => value === true,
				message: ''
			}),
			otherwise: Yup.bool().required('')
		})
	});

	const [ composition, setComposition ] = useState([
		{ is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: '' },
		{ is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''}
	].map((data) => {
		if (data.libelle === initialValues.otherDispositions.floralComposition.status){
			return { ...data, is_selected: true}
		}
		else {
			return data;
		}
	}))

	const [ typeOfCoffin, setTypeOfCoffin] = useState(
		initialValues.otherDispositions.typeOfCoffin == '' ? null : initialValues.otherDispositions.typeOfCoffin
	)

	const [ sejour, setSejour ] = useState([
		{is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: ''},
		{is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''},
		{is_selected: false, libelle: 'Je laisse le choix à mes proches le jour venu', icon_code: 'au', infobulle: ''},
	]);

	const [ soins, setSoins ] = useState([
		{is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: ''},
		{is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''},
	].map((data) => {
		if (data.libelle == initialValues.otherDispositions.conservationCare) {
			return {...data, is_selected: true}
		}
		else {
			return data;
		}
	}));

	const [avis, setAvis] = useState([
		{is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: ''},
		{is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''},

	].map((data) => {
		if (data.libelle == initialValues.otherDispositions.pressNotices)
			return {...data, is_selected: true}
		else
			return data;

	}));


	const [fairepart, setFairePart] = useState([
		{is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: ''},
		{is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''},

	].map((data) => {
		if (data.libelle == initialValues.otherDispositions.announcement)
			return {...data, is_selected: true}
		else
			return data;

	}));

	/**
	 * Onchange Type de cerceuil
	 *
	 * @param e
	 */
	const onChangeTypeOfCoffin = e => {
		setTypeOfCoffin(e.target.value);

		formik.setFieldValue('otherDispositions.typeOfCoffin', e.target.value);
	}

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	});

	/**
	 * Onchange group radio
	 *
	 * @param {number} id
	 * @param {string} group
	 */
	const onChangeGroupRadio = (id, group) => {
		switch (group) {
			case 'composition':
				setComposition(composition.map((data, index) => {
					if (index == id) {
						formik.setFieldValue('otherDispositions.floralComposition.status', data.libelle)
						formik.setTouched({...formik.touched, "otherDispositions.floralComposition.status": true})

						return { ...data, is_selected: true}
					}
					else {
						return { ...data, is_selected: false}
					}
				}))

				break;

			case 'sejour':
				setSejour(sejour.map((data, index) => {
					if ( index == id ) {
						formik.setFieldValue("otherDispositions.funeralHomeStay", data.libelle);
						formik.setTouched({...formik.touched, "otherDispositions.funeralHomeStay": true})

						return {...data, is_selected: true}
					}
					else {
						return { ...data, is_selected: false };
					}
				}));

				break;

			case 'soins':
				setSoins(soins.map((data, index) => {
					if (index == id) {
						formik.setFieldValue("otherDispositions.conservationCare", data.libelle);
						formik.setTouched({...formik.touched, "otherDispositions.conservationCare": true})

						return { ...data, is_selected: true}
					}
					else {
						return { ...data, is_selected: false}
					}
				}))

				break;

			case 'fairepart':
				setFairePart(fairepart.map((data, index) => {
					if (index == id) {
						formik.setFieldValue("otherDispositions.announcement", data.libelle)
						formik.setTouched({...formik.touched, "otherDispositions.announcement": true})
						return {...data, is_selected: true}
					} else {
						return {...data, is_selected: false}
					}

				}));
				break;

			case 'avis':
				setAvis(avis.map((data, index) => {
					if (index == id) {
						formik.setFieldValue("otherDispositions.pressNotices", data.libelle)
						formik.setTouched({...formik.touched, "otherDispositions.pressNotices": true})
						return {...data, is_selected: true}
					} else {
						return {...data, is_selected: false}
					}

				}));
				break;
		}
	}

	/**
	 * Action when checkbox clicked
	 *
	 * @param value
	 * @param name
	 */
	const onChangeChecked = (value, name) => {

		formik.setFieldValue(name, !value)
		formik.setTouched({...formik.touched, name: true})

	}

	useEffect(() => {
		checkReadyForSaving(Object.keys(formik.touched).length > 0);

		formik.validateForm().then((res) => {

			datas[1] = formik.values;
			setdatas(datas);
			if (Object.keys(res).length == 0) {
				dispatchStepEvent('SET_STEP_READY', true);
			} else {
				dispatchStepEvent('SET_STEP_READY', false)
			}
		});

	}, [formik.values]);

	return (
		<div id={"step-3"} className={"step-form"}>

			<div className="card-banner info" dangerouslySetInnerHTML={{__html: texteInfos}} />

			<form>
				<div className="form-card">
					<div className="card-header">
						Autres dispositions <span style={{marginLeft: '5px'}}>  (facultatif)</span> :
					</div>

					<div className="card-body">

						<div className="bloc question picto  valid under-ligne">
							<h2 className="title small ">Sélectionnez votre choix :</h2>
						</div>

						<div className="bloc question picto valid  under-ligne">
							<h2 className="title ">Composition florale : </h2>

							<GroupRadioButton onChange={onChangeGroupRadio} group={'composition'} radios={composition}/>
							<input
								hidden={true}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
						   		value={formik.values.otherDispositions.floralComposition}
						   		id="otherDispositions.floralComposition"
								name="otherDispositions.floralComposition"
							/>

							{
								composition.map((comp, index) => {
									if (comp.libelle == 'Oui' && comp.is_selected) {
										return (
											<div key={index} className="form-group ">
												<label
													className="control-label"
													htmlFor="typeComposition"
												>
													Précisez le type de composition souhaité :
												</label>

												<div className="container-input">
													<textarea
														maxLength={250}
														className="form-control"
														onBlur={formik.handleBlur}
														onChange={formik.handleChange}
														value={formik.values.otherDispositions.floralComposition.type}
														id="otherDispositions.floralComposition.type"
														name="otherDispositions.floralComposition.type" type="text"
														placeholder=""
														title="Précisez le type de composition souhaité"
													/>

													<span>
														{formik.values.otherDispositions.floralComposition.type.length}/250 caractères
													</span>
												</div>
											</div>
										)
									}
								})
							}
						</div>

						<div className="bloc question picto valid  under-ligne">
							<h2 className="title ">Type de cercueil souhaité :</h2>

							<div className="form-group  ">
								<div role="group" className="btn-group btn-group-radio-column btn-group-radio">
									<label className="bouton-form-radio">
										<input
											readOnly={true}
											defaultValue={'Standard'}
											checked={typeOfCoffin === "Standard"}
											onChange={onChangeTypeOfCoffin}
											type="radio"
											title="Civilité"
										/>
										Standard
									</label>

									<label className="bouton-form-radio">
										<input
											readOnly={true}
											defaultValue={'Classique'}
											checked={typeOfCoffin === "Classique"}
											onChange={onChangeTypeOfCoffin}
											type="radio"
											title="Civilité"
										/>
										Classique
									</label>

									<label className="bouton-form-radio">
										<input
											readOnly={true}
											defaultValue={'Prestige'}
											checked={typeOfCoffin === "Prestige"}
											onChange={onChangeTypeOfCoffin}
											type="radio"
											title="Civilité"
										/>
										Prestige
									</label>
								</div>

								<input
									hidden={true}
									onBlur={formik.handleBlur}
									onChange={formik.handleChange}
							   		value={formik.values.otherDispositions.typeOfCoffin}
							   		name="otherDispositions.typeOfCoffin" id="otherDispositions.typeOfCoffin"
								/>
							</div>
						</div>

						<div className="bloc question picto valid under-ligne">
							<h2 className="title ">Accueil des familles en salon funéraire :

								<CustomTooltip
									content={"Lieu de repos du défunt, la chambre funéraire permet aux proches de se recueillir pendant la période qui précède la cérémonie des obsèques."}
								/>

							</h2>



							<GroupRadioButton
								onChange={onChangeGroupRadio}
								group={'sejour'}
								radios={sejour}
							/>

							<input
								hidden={true}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
						   		value={formik.values.otherDispositions.funeralHomeStay}
						   		id="otherDispositions.funeralHomeStay"
								name="otherDispositions.funeralHomeStay"
							/>
						</div>

						<div className="bloc question picto valid under-ligne">
							<h2 className="title ">Soins de conservation :
								<CustomTooltip
									content={"Ils associent toilette funéraire et procédés de conservation particulièrement recommandés lorsqu'il est fait le choix d'une présentation du défunt en salon funéraire."}
								/>
							</h2>

							<GroupRadioButton
								onChange={onChangeGroupRadio}
								group={'soins'}
								radios={soins}
							/>

							<input
								hidden={true}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
						   		value={formik.values.otherDispositions.conservationCare}
						   		id="otherDispositions.conservationCare"
								name="otherDispositions.conservationCare"
							/>
						</div>

						<div className="bloc question picto valid under-ligne">
							<h2 className="title ">Parution d'un avis de décès dans la presse :</h2>

							<GroupRadioButton
								onChange={onChangeGroupRadio}
								group={'avis'}
								radios={avis}
							/>

							<input
								hidden={true}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
						   		value={formik.values.otherDispositions.pressNotices}
						   		id="otherDispositions.pressNotices"
								name="otherDispositions.pressNotices"
							/>
						</div>

						<div className="bloc question picto valid under-ligne">
							<h2 className="title ">Réalisation de faire-part :</h2>

							<GroupRadioButton
								onChange={onChangeGroupRadio}
								group={'fairepart'}
								radios={fairepart}
							/>

							<input
								hidden={true}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
						   		value={formik.values.otherDispositions.announcement}
						   		id="otherDispositions.announcement"
								name="otherDispositions.announcement"
							/>

							{
								formik.values.otherDispositions.announcement === "Oui" && (
									<>
										<h2 className="title ">
											Faire part
										</h2>

										<div className="form-group ">
											<div className="container-input">
												<textarea
													maxLength={500}
													className="form-control"
													onBlur={formik.handleBlur}
													onChange={formik.handleChange}
													value={formik.values.otherDispositions.announcementText}
													name="otherDispositions.announcementText"
													type="text"
													placeholder=""
													title="Veuillez rédiger le faire-part"
												/>

												<span>
													{formik.values.otherDispositions.announcementText.length}/500 caractères
												</span>
											</div>
										</div>
								</>
								)
							}

						</div>

						<div className="bloc question picto valid under-ligne">
							<h2 className="title ">
								Informations complémentaires <p className="small"> (musiques et/ou textes
								souhaités lors de la cérémonie...)</p> :
							</h2>

							<div className="form-group ">
								<div className="container-input">
									<textarea
										maxLength={500}
										className="form-control"
										onBlur={formik.handleBlur}
										onChange={formik.handleChange}
										value={formik.values.otherDispositions.otherDispositions}
										name="otherDispositions.otherDispositions"
										type="text"
										placeholder=""
										title="Précisez le type de composition souhaité"
									/>

									<span>
										{formik.values.otherDispositions.otherDispositions.length}/500 caractères
									</span>
								</div>
							</div>
						</div>

						<div className="bloc question picto valid under-ligne">
							<div className="reponses row">
								<div className="rep checkbox ">
									<CheckBox
										checkValue={formik.values.authorizeSensitiveData}
										onChange={onChangeChecked}
										name="authorizeSensitiveData"
										texte={'J’autorise le responsable de traitement visé dans les conditions générales à traiter les données sensibles que j’inscris dans le présent formulaire, afin que le mandataire veille au respect de mes Volontés Essentielles et accomplisse toute action impliquée par cette finalité.'}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	)
}

export default StepWillsOther;
